import styled from "@emotion/styled";
import { Radio } from "@rebass/forms";

const RadioButton = styled(Radio)``;

RadioButton.defaultProps = {};

export default RadioButton;
